import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { FacilityInventoryCountFileUploadViewStore } from "application/facility-inventory/stores";
import { FacilityInventoryCountFileUploadTemplate } from "themes/application/facility-inventory/pages";

@setCurrentView((rootStore) => new FacilityInventoryCountFileUploadViewStore(rootStore), "facilityInventoryCountFileUploadViewStore")
@observer
class FacilityInventoryCountFileUpload extends React.Component {
    render() {
        return <FacilityInventoryCountFileUploadTemplate { ...this.props }/>
    }
}

export default FacilityInventoryCountFileUpload;
